import React, { useEffect, useState } from 'react'
import { SelectInputWidget } from "../SelectInputWidget";
import { TextInputWidget } from "../TextInputWidget";
import { ReactComponent as TrvPiHome36 } from '@trv-ebus/tds-icons/dist/assets/icons/product/svg/trv-pi-home-36.svg'
import { ReactComponent as TrvPiCondo36 } from '@trv-ebus/tds-icons/dist/assets/icons/product/svg/trv-pi-condo-36.svg'
import { ReactComponent as TrvPiRenter36 } from '@trv-ebus/tds-icons/dist/assets/icons/product/svg/trv-pi-renter-36.svg'
import { ReactComponent as TrvLogo2colorBlackSmall } from '@trv-ebus/tds-icons/dist/assets/icons/logos/svg/trv-logo-2color-black-small.svg'
import { ReactComponent as TrvPiCar36 } from '@trv-ebus/tds-icons/dist/assets/icons/product/svg/trv-pi-car-36.svg'
import './Widget.scss'
import { ReactComponent as ArrowUpRightBox118 } from '@trv-ebus/tds-icons/dist/assets/icons/functional/svg/arrow-up-right-box-1-18.svg'
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import { TdsButton, TdsCard, TdsCardContent } from '@trv-tds/react';
import { validateZip } from './ZipValidation';
import { ReactComponent as TrvLogo1colorWhiteSmall } from '@trv-ebus/tds-icons/dist/assets/icons/logos/svg/trv-logo-1color-white-small.svg'
import { getLob } from '../../../utils/LOBUtils';
import { unique } from 'webpack-merge';
import he from 'he';

export const Widget = ({ widgetId }) => {
    const [zip, setZip] = useState();
    const [isValidZip, setIsValidZip] = useState(false);
    const [highContrastCheck, setHighContrastCheck] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState('Select');
    const [validProduct, setValidProduct] = useState(true);
    const [validZip, setValidZip] = useState(true);
    const [productIcons, setProductIcons] = useState()
    const [disabled,setDisabled] = useState(false)
    window.addEventListener("load", function (e) {
        const height = document.body.scrollHeight;
        parent.postMessage(`${height}px`, "*");
      });
     
      window.addEventListener("resize", function (e) {
        const height = document.body.scrollHeight;
        parent.postMessage(`${height}px`, "*");
      });
    const IconValues = {
        Auto: ['Auto'],
        Condo: ['Condo'],
        Home: ['Home'],
        Renters: ['Renters'],
        'Auto+Home': ['Auto', 'Home'],
        'Auto+Renters': ['Auto','Renters'],
        'Auto+Condo': ['Auto','Condo']
    }
    const validateFields = async () => {
        const newTab = window.open("about:blank", '_blank');
        if (selectedProduct === 'Select') {
            setValidProduct(false);
        }
        else {
            setValidProduct(true);
        }
        let validateZipResponse
        if (!zip || zip == "" || zip?.length < '5' || zip?.length === 0 || zip?.length > '5') {

            setValidZip(false);
        } if (zip && zip?.length == '5') {
            validateZipResponse = await validateZip(zip,widgetId);
            if (validateZipResponse?.messageStatus?.statusCode == "Success") {
                setValidZip(true);
            } else {
                setValidZip(false);
            }
        }
        if ((selectedProduct != 'Select') && zip && zip.length === 5 && validateZipResponse?.messageStatus?.statusCode == "Success") {
            let lob = getLob(selectedProduct);
            const clickTrackerURL = `${WidgetData.clickTrackerURL}&lob=${lob}&zipCode=${zip}`;
            newTab.location.href = clickTrackerURL;
        }
    }

    const [WidgetData, setWidgetData] = useState()
    const [status, setStatus] = useState()
    useEffect(() => {
        const GetWidgetData = async () => {
            try {
                const TARGET_URL = `${process.env.REACT_APP_PROFILE_ACCESSOR_XAPI_URL}/widget?id=${widgetId}`;
                const INVOKE_XAPI_CONFIG = {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-TRV-APPLICATION': process.env.REACT_APP_X_APP_NAME,
                        'X-TRV-APPLICATION-VERSION': '1.0.0',
                        'X-TRV-TRANSACTION-ID': uuidv4(),
                        'X-TRV-CORRELATION-ID': null,

                    },

                }
                const res = await axios.get(TARGET_URL, INVOKE_XAPI_CONFIG);
                let data = res.data.widget;
                try {       
                    data.clickTrackerURL = he.decode(data.clickTrackerURL);
                } catch (error) {
                    console.error("Error decoding click tracker URL encoded", data.clickTrackerURL);
                    throw error;
                }
                setWidgetData(data)
            } catch (e) {
                setStatus('Error')
                console.log(e);
            }
        }
        GetWidgetData()
    }, []);

    useEffect(() => {
        const height = window.innerHeight;
        const width = window.innerWidth
        if (!validProduct || !validZip) {
            if ((height > 250 && width < 968))
                document.getElementsByClassName('get-quote')[0].style.marginTop = '40px';
            
            else
                document.getElementsByClassName('footerAlign')[0].style.marginTop = '20px';

        }
       
        
    }, [validProduct, validZip])

    useEffect(()=> {
        if (WidgetData && WidgetData?.colorPalette === 'HighContrast') {
            setHighContrastCheck(true)
        }
        const updatedIcons = ()=> {
            if(WidgetData && WidgetData.products){ 
                const uniqueIcons = new Set()
                WidgetData.products.forEach(product=> {
                    const icons = IconValues[product]
                    if(icons){
                        icons.forEach(icon => 
                            uniqueIcons.add(icon)
                        );
                    }
                   
                });
               
                const updatedIconsArray =  Array.from(uniqueIcons)
                setProductIcons(updatedIconsArray)
            }
        }
        updatedIcons()
    },[WidgetData])
    useEffect(()=>{
        if (process.env.REACT_APP_ENABLE_GET_A_QUOTE_BUTTON=='false'){
            setDisabled(true);
        }else{
            setDisabled(false);
        }
    },[]);
    const IconColor = highContrastCheck ? 'white' : '#003557'
    const iconMapping = {
         'Renters': <span style={{ padding: '10px' }}><TrvPiRenter36 color={IconColor} className="tds-icon-36" viewBox="0 0 36 32" /> </span>,
         'Condo': <span style={{ padding: '10px' }}><TrvPiCondo36 color={IconColor} className="tds-icon-36" /></span>,
         'Home': <span style={{ padding: '6px' }}><TrvPiHome36 color={IconColor} className="tds-icon-36" viewBox="0 0 36 36" /></span>,
         'Auto': <span style={{ padding: '6px' }}><TrvPiCar36 color={IconColor} className="tds-icon-36" viewBox="0 0 36 31" /></span>,
     };

    function getIcon(value) {
        return iconMapping[value]
    }

    if (status == 'Error' || !WidgetData) {
        return <></>
    }
    let SelectInputLobs = []
    if (WidgetData && WidgetData.products) {
        SelectInputLobs = ['Select', ...WidgetData.products]
    }

    const phoneNumber = WidgetData.callCTA.match(/\d{1}-\d{3}-\d{3}-\d{4}/);
    const phno = phoneNumber ? phoneNumber[0] : '';
    const [CTAPreText, CTAPostText] = WidgetData.callCTA.split(phoneNumber);

    const HighContrast = { backgroundColor: '#002D4B', color: 'white' };
    const neutralColour = { backgroundColor: 'white' }
    const appliedStyle = highContrastCheck ? HighContrast : neutralColour
    const appliedBackgroundColor = appliedStyle.backgroundColor;
    const appliedFontColor = appliedStyle.color;
    const staticColorText = highContrastCheck ? HighContrast.color : '#003557'
    const phonenoColor = highContrastCheck ? HighContrast.color : '#007395'
    const bodyCopyColor = highContrastCheck ? HighContrast.color :'#46494D'
    return (
        <div className={'widget-container'} style={{ backgroundColor: `${appliedBackgroundColor}`, color: `${appliedFontColor}`, fontFamily: 'Batterson Sans' }}>
            <div className="column1">
                {WidgetData?.colorPalette === "HighContrast"} <div className={'logo'}>
                    {highContrastCheck ? <TrvLogo1colorWhiteSmall className={'tds-icon-trv-logo-small logoPadding'} /> : <TrvLogo2colorBlackSmall className='tds-icon-trv-logo-small logoPadding' />}
                </div>
                {WidgetData?.bodyHeader && <div className={'bodyheader'} style={{ color: `${staticColorText}`}} >{WidgetData.bodyHeader} </div>}
                {WidgetData?.bodyCopy && <div className={'bodyText'} style={ {color: `${bodyCopyColor}`}}>{WidgetData.bodyCopy}</div>}
                {WidgetData.displayProductIcons && <div>  
                 {productIcons && productIcons?.map(function (option, index) {
                    return (
                        <span key={index}>{getIcon(option)}</span>
                    );
                })}
                </div>}
            </div>
            <div className="column2" >
                <div className="dynamic-row">
                    <div className="text">
                        <div className="box1">
                            <SelectInputWidget options={SelectInputLobs} label={'Products'} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct}
                                validProduct={validProduct} setValidProduct={setValidProduct} highContrastCheck = {highContrastCheck} /></div>
                        <div className="box2" >
                            <TextInputWidget placeholder={'00000'} label={'ZIP Code'} regexMessage={"ZIP code is required."} zip={zip} setZip={setZip} setIsValidZip={setIsValidZip} validZip={validZip} setValidZip={setValidZip} highContrastCheck = {highContrastCheck} />
                        </div>
                    </div>
                    <div className="get-quote">                  
                        <TdsButton onClick={() => { validateFields() }} variant="primary" style={{width:'max-content', marginTop:'5px' }} disabled={disabled} >{WidgetData.buttonLabel} <ArrowUpRightBox118 className="tds-icon-18"  /></TdsButton>
                    </div>                    
                </div>
                <div className={'Phoneno footerAlign'} style={{ color: `${bodyCopyColor}`,fontSize: '12px' }}>{CTAPreText} <a style={{ color: `${phonenoColor}`, fontWeight:'600', textDecoration: 'none'}} href={`tel:+${phno}`}> {phno}</a>{CTAPostText}</div>
                    {WidgetData?.disclaimer && <div className={'bodyText footerAlign2'} style={{ color: `${bodyCopyColor}`, fontSize: '12px' ,fontWeight:400, lineHeight:'19.2px', paddingBottom:'2px', whiteSpace:'pre-wrap'}}><i>
                    {WidgetData.disclaimer}</i></div>}
            </div>
        </div>

    );
}
